import { createTheme } from "@mui/material";

export const theme = createTheme({
	palette: {
		primary: {
			main: "#3f2a55",
		},
		secondary: {
			main: "#85be55",
			light: "#85be55",
			dark: "#85be55",
		},
		background: {
			default: "#f4f4f4",
			paper: "#f4f4f4",
		},
		action:{
			disabledBackground: "#e6e6e6",
		}
	},
	components: {
		MuiFormControl: {
			styleOverrides: {
				root: {
					'&.fileLibelle:hover': {
						backgroundColor: '#d8d8d8',
					},
				},
			},
		},
	},
});
